import { render, staticRenderFns } from "./windowParamsList.vue?vue&type=template&id=2f9e9be4&scoped=true&"
import script from "./windowParamsList.vue?vue&type=script&lang=js&"
export * from "./windowParamsList.vue?vue&type=script&lang=js&"
import style0 from "./windowParamsList.vue?vue&type=style&index=0&id=2f9e9be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e9be4",
  null
  
)

export default component.exports